import { CLIENT_USER_FILTERS_DEFAULT as DEFAUT } from "../clientFiltersDefault";

// Règle PER-2430 : un client « sans fiche » (typeClient NONE) n'a ni société ni
// contrat ; les champs qui en dépendent sont vidés et désactivés. Le statut de
// contrat passe à « tous » (""), pas à son défaut « en cours ».
export const CHAMPS_LIES_AU_CONTRAT = [
  "numeroContrat",
  "nomSociete",
  "sirenOuSiret",
  "compagniesAssurances",
  "typesProduits",
  "produits",
  "statutContrat",
  "auMoins1Contrat",
  "avecEcheancierOuMensualisation",
  "partenaire",
];

export const estSansFiche = (filtres) => filtres.typeClient === "NONE";

export const appliquerRegleSansFiche = (filtres) => {
  if (!estSansFiche(filtres)) return filtres;
  const vides = CHAMPS_LIES_AU_CONTRAT.reduce((acc, cle) => {
    acc[cle] = cle === "statutContrat" ? "" : DEFAUT[cle];
    return acc;
  }, {});
  return { ...filtres, ...vides };
};
